// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2fZqU","validationTips":"StatementDescriptor_validationTips__3t-Ja"};